import React from 'react';
import { Trail } from '../../models/Trail';
import ShowTrail from './ShowTrail';

type TrailMarkersProps = {
	trails: Trail[];
	activeIndex: number;
};

// @ts-ignore

const TrailMarkers: React.FC<TrailMarkersProps> = ({
	trails,
	activeIndex,
}: TrailMarkersProps) => {
	return trails.map((trail, idx) => {
		return (
			<ShowTrail
				key={`map-trails-${trail.id}`}
				trail={trail}
				isActive={activeIndex === idx}
				hideIntermediateMarkers={true}
			/>
		);
	});
};

export default TrailMarkers;
